import(/* webpackMode: "eager" */ "/vercel/path0/app/(mitra)/products/[...product_id]/page.js")